import type { FC } from "react";
import { useCallback, useMemo } from "react";
import { translate } from "app/filters/i18nFilter";
import { swSettings } from "app/common/services/swSettings";
import { SwTrack } from "app/services/SwTrack";
import { SubsectionHeader } from "@similarweb/ui-components";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { useCurrentStateAndParams } from "@uirouter/react";

const DashboardsNavBarHeader: FC = () => {
    const { state } = useCurrentStateAndParams();
    const { name: currentPage } = state;

    const handleClick = useCallback(() => {
        proNavigator.go("dashboard");
    }, []);

    const handleButtonClick = () => {
        SwTrack.all.trackEvent("Dashboards", "click", "Side Bar/Add a New Dashboard");
        proNavigator.go("dashboard-gallery");
    };

    const isButtonDisabled = useMemo(() => {
        return (
            (proNavigator.current() as any).disableNewDashboardButton ||
            swSettings.components.Dashboard.resources.IsReadonly
        );
    }, [currentPage]);

    return (
        <SubsectionHeader
            text={translate("sidenav.dashboard.title")}
            onAddClick={handleButtonClick}
            onClick={handleClick}
            id={"sidenav.dashboard.title"}
            dataAutomationAddButton="add.dashboard"
            isDisabled={isButtonDisabled}
        />
    );
};

export default DashboardsNavBarHeader;
